module.exports = __webpack_public_path__ + "img/new_dawn.27315cbf.jpg";